import React from 'react';


const About = () => {
 
  return (
    <div>
     This is about
    </div>
  )
}

export default About
